import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const SubTitle: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='subtitles' clipPath='url(#clip0_4714_46488)'>
      <path
        id='Vector'
        d='M17.2 3H2.8C1.81 3 1 3.7875 1 4.75V15.25C1 16.2125 1.81 17 2.8 17H17.2C18.19 17 19 16.2125 19 15.25V4.75C19 3.7875 18.19 3 17.2 3ZM17.2 15.25H2.8V4.75H17.2V15.25ZM4.6 8.25H6.4V10H4.6V8.25ZM4.6 11.75H11.8V13.5H4.6V11.75ZM13.6 11.75H15.4V13.5H13.6V11.75ZM8.2 8.25H15.4V10H8.2V8.25Z'
        fill='white'
        fillOpacity='0.6'
      />
    </g>
    <defs>
      <clipPath id='clip0_4714_46488'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default SubTitle;
